import moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Desktop, Mobile } from '../../../App';
import { BV, formatVP } from '../../../helpers/helperFunctions';
import { SectionSeparator } from '../../../styles/GlobalComponents';
import { getVolume } from '../myTeamBackOffice.actions';
import {
  FlexCenterEqual,
  FlexJustifyCenter,
  VolumesDate,
  VolumesDesktop,
  VolumesInfo
} from '../MyTeamBackofficeStyled';
import UserVolume from './UserVolume';
import Week from './Week';

const Volume = ({ tab }) => {
  const { t } = useTranslation('myTeam');
  const { volumeInfo } = useSelector((state) => state.myTeamBackoffice);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!volumeInfo) dispatch(getVolume());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // if (isLoading) return <Spinner fullScreen={true} />;

  if (!volumeInfo)
    return (
      <div
        style={{
          fontWeight: 'normal',
          fontSize: '16px',
          lineHeight: '24px',
          color: '#b5a8a8'
        }}>
        {t('volume_points_page.no_vol_points')}
      </div>
    );

  return (
    <>
      <FlexJustifyCenter
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%'
        }}>
        <UserVolume volumeInfo={volumeInfo?.user} tab={tab} />

        <SectionSeparator
          margin={'32px 0 40px 0'}
          style={{ maxWidth: '680px' }}
        />
        <Desktop style={{ width: '100%' }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative'
            }}>
            {volumeInfo?.weekVolumeInfos?.map((week, i) => {
              return (
                <VolumesDesktop key={i} isCurrentWeek={i === 0}>
                  <div>
                    <VolumesDate>
                      {moment(week.weekStartDate).format('DD MMM')} {' - '}
                      {moment(week.weekEndDate).format('DD MMM YY')}
                    </VolumesDate>
                    <VolumesInfo>
                      <h1>{t('volume_points_page.initial_balance')}</h1>
                      <FlexCenterEqual>
                        <div>
                          <h2>
                            {t('left_team')} {BV}
                          </h2>
                          <h3>{formatVP(week.startLeftLegVolume)}</h3>
                        </div>
                        <div>
                          <h2>
                            {t('right_team')} {BV}
                          </h2>
                          <h3>{formatVP(week?.startRightLegVolume)}</h3>
                        </div>
                      </FlexCenterEqual>
                    </VolumesInfo>
                    <VolumesInfo>
                      <h1>{t('volume_points_page.new_balance')}</h1>
                      <FlexCenterEqual>
                        <div>
                          <h2>
                            {t('left_team')} {BV}
                          </h2>
                          <h3> {formatVP(week.newLeftLegVolume)}</h3>
                        </div>
                        <div>
                          <h2>
                            {t('right_team')} {BV}
                          </h2>
                          <h3>{formatVP(week.newRightLegVolume)}</h3>
                        </div>
                      </FlexCenterEqual>
                    </VolumesInfo>
                  </div>
                </VolumesDesktop>
              );
            })}
          </div>
        </Desktop>

        <Mobile style={{ width: '100%' }}>
          {volumeInfo?.weekVolumeInfos?.map((week, i) => {
            return (
              <Week
                key={i}
                week={week}
                isCurrentWeek={i === 0}
                numOfWeek={volumeInfo?.weekVolumeInfos.length - i}
              />
            );
          })}
        </Mobile>
        {/* <LevelOneInfoComponent /> */}
      </FlexJustifyCenter>
    </>
  );
};

export default Volume;
